import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function Content16({data}) {
    const {content16Text, content16Title} = data
    return (
        <div className='left-right-pattern-image-wrap font-white g-content-16 green-bg-sec'>
            <div className='container sm-container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <h2 className='heading-level-1-i'>{content16Title && parser(content16Title)}</h2>
                        <p>{content16Text && parser(content16Text)}</p>
                    </div>
                </div>
            </div>
            <div className='g-lt-pattern-1'>
                <StaticImage
                    src='../../../images/lt-pattern-green-image.png'
                    alt='image'
                />
            </div>
            <div className='g-rt-pattern-1'>
                <StaticImage
                    src='../../../images/rt-pattern-green-image.png'
                    alt='image'
                />
            </div>
            <div className='g-btm-pattern-1'>
                <StaticImage
                    src='../../../images/btm-pattern-green-image.png'
                    alt='image'
                />{' '}
            </div>
        </div>
    )
}
